import fwFooterLogo from "../assets/fw_logo.png";
import fwLogo from "../assets/floorwalk_logo.webp";
import hsLogo from "../assets/hs_brand_logo.jpg";

const tenants = {
  floorwalk: {
    name: "FloorWalk",
    fullName: "FloorWalk Consultants Pvt. Ltd.",
    logo: fwLogo,
    footerLogo: fwFooterLogo,
    favicon: "/favicon.ico",
    supportEmail: "contactus@floorwalk.in",
    paymentQueryMail: "accounts@floorwalk.in",
    supportContactsShopper: "",
    supportContactsAccounts: "",
    socialMedia: {
      instagram: "https://www.instagram.com/floorwalk/",
      linkedin: "https://in.linkedin.com/company/floorwalk",
      facebook: "https://www.facebook.com/FloorWalk",
      twitter: "https://twitter.com/FloorWalk",
    },
    playStoreUrl : "https://play.google.com/store/apps/details?id=com.bahnisikha_dhar.FloorwalkAuditorPortal",
    appStoreUrl : "https://apps.apple.com/in/app/floorwalk-shopper/id6759602541",
    colors: {
      "--common-color": "#003c5d",
      "--blue-shade": "#007dc1",
      "--green-shade": "#8dc63f",
      "--gray-shade": "#aaa",
      "--danger-red-shade": "#d9534f",
    },
    clientUrl: "https://client.floorwalk.in/login",
    baseUrl: "https://portal.floorwalk.in/",
    features: {
      chatbot: true,
    },
  },
  hsbrandsasia: {
    name: "HS Brands",
    fullName: "HS Brands Private Limited",
    logo: hsLogo,
    footerLogo: hsLogo,
    favicon: "/hsbrand_favicon.ico",
    supportEmail: "shopper.relations@hsbrandsasia.com",
    paymentQueryMail: "accounts@hsbrandsasia.com",
    supportContactsShopper: "9663772288",
    supportContactsAccounts: "8088940494",
    socialMedia: {
      instagram: "https://www.instagram.com/mystery_shopping_expert/",
      linkedin: " https://www.linkedin.com/company/hs-brands-international-asia/",
      facebook: " https://www.facebook.com/mysteryshoppingexpert ",
      twitter: "https://x.com/HSBrands",
    },
    playStoreUrl : "https://play.google.com/store/apps/details?id=com.hsbrandsasia.shopper",
    appStoreUrl : "https://apps.apple.com/in/app/hsb-lenz/id6791076777",
    colors: {
      "--blue-shade": "#8f061e",
      "--green-shade": "#0f1d38",
    },
    clientUrl: "https://client.hsbrandsasia.com/login",
    baseUrl: "https://portal.hsbrandsasia.com/",
    features: {
      chatbot: false,
    },
  },
};

export default tenants;